import useApiMutation from 'shared/hooks/use-api-mutation';
import {SaleProps} from '../types';
import productsKeys from '../util/products-keys';
import useQueryHelpers from 'shared/hooks/use-query-helpers';

const useCreateSale = () => {
  const {create} = useQueryHelpers();

  const onSuccess = (data: SaleProps) =>
    create(productsKeys.sales(data.productId!), data);

  return useApiMutation<SaleProps>({
    url: '/sales',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar promoção',
    successTitle: 'Cadastrar promoção',
    successMessage: 'Promoção cadastrada com sucesso',
    redirectUrl: (data) => `/menu/products/${data.productId}/sales`,
    onSuccess,
  });
};

export default useCreateSale;
